import React, { useState, useEffect } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { ParentContentCardMultiHeader } from '../../common/ParentContentCardMultiHeader';
import { AiModelSettingForm } from './AiModelSettingForm';
import { aiModelTypes, CLAUDE_AI, DEEPSEEK_AI, OPEN_AI } from 'drapcode-constant';
import { convertConstantCaseToTitleCase } from '../../../common/utils/api_utils';
import IconImage from '../../../common/ui/IconImage';

export const AiModelTab = ({
  projectId,
  projectDetail,
  version,
  updateAiModelConfig,
  activeModelType,
  switchAIModelTypeTab,
}) => {
  const { aiModelConfigs } = projectDetail;
  const loadAiModelSetting = (aiModelType) => {
    const aiModelConfig =
      aiModelConfigs && aiModelConfigs.find((amc) => amc.modelType === aiModelType);
    return (
      <AiModelSettingForm
        projectId={projectId}
        version={version}
        aiModelType={aiModelType}
        aiModelConfig={aiModelConfig}
        updateAiModelConfig={updateAiModelConfig}
      />
    );
  };

  const loadAiModelIcon = (aiModelType) => {
    let aiModelIcon = '';
    switch (aiModelType) {
      case OPEN_AI:
        aiModelIcon = 'openai.svg';
        break;
      case CLAUDE_AI:
        aiModelIcon = 'claudeai.svg';
        break;
      case DEEPSEEK_AI:
        aiModelIcon = 'deepseekai.svg';
        break;
      default:
        aiModelIcon = 'drapcode.png';
        break;
    }
    return aiModelIcon;
  };

  return (
    <ParentContentCardMultiHeader
      title="AI Model Configuration"
      icon="aiModelConfig"
      bgColor="drapcode-violet"
      projectId={projectId}
      version={version}
      CtaComponent={''}
    >
      <>
        <Nav pills className="nav-pills-primary drapcode-nav-pills">
          {aiModelTypes.map((aiModelType) => (
            <NavItem key={aiModelType}>
              <NavLink
                className={classnames({ active: activeModelType === aiModelType })}
                onClick={() => switchAIModelTypeTab(aiModelType)}
              >
                <IconImage
                  src={loadAiModelIcon(aiModelType)}
                  width={20}
                  height={20}
                  alt={aiModelType}
                  style={{ backgroundColor: 'white', borderRadius: '50px', padding: '2px' }}
                />
                &nbsp;
                {convertConstantCaseToTitleCase(aiModelType, 'AI')}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        <TabContent activeTab={activeModelType} className="my-5">
          {aiModelTypes.map((aiModelType) => (
            <TabPane tabId={aiModelType} key={aiModelType}>
              {loadAiModelSetting(aiModelType)}
            </TabPane>
          ))}
        </TabContent>
      </>
    </ParentContentCardMultiHeader>
  );
};
